const getType = obj => {
	return Object.prototype.toString.call(obj)
}
export default {
	state: {
		token: "",
		currentModel: sessionStorage.getItem("currentModel"), // 当前模式
		currentLanguage: localStorage.getItem('locale'),//当前语言
		// isAuth: false, // false:普通用户  true：管理员
		// 面包屑
		breadcrumb: [{
			label: "首页"
		}],
		// 用户模式菜单
		userModelMenus: [
			// 暂时隐藏"我的应用"，非管理员登录后直接看到"我的账户"
			// {
			// 	label: "我的应用",
			// 	path: "/portalApplication",
			// 	img: "/imgs/client.png",
			// 	imgSelect: "/imgs/clientSelect.png"
			// },
			{
				label: "我的账户",
				path: "/portalAccount",
				img: "/imgs/user.png",
				imgSelect: "/imgs/userSelect.png"
			}
		],
		// 管理员模式菜单
		managerModelMenu: [{
				label: "账户管理",
				path: "/userManage",
				img: "/imgs/user.png",
				imgSelect: "/imgs/userSelect.png"
			},
			{
				label: "部门管理",
				path: "/department",
				img: "/imgs/department.png",
				imgSelect: "/imgs/departmentSelect.png"
			},
			{
				label: "资源组",
				path: "/groupManage",
				img: "/imgs/group.png",
				imgSelect: "/imgs/groupSelect.png"
			},
			{
				label: "用户联合",
				path: "/userContact",
				img: "/imgs/userContact.png",
				imgSelect: "/imgs/userContactSelect.png"
			},
			{
				label: "应用管理",
				path: "/clientManage",
				img: "/imgs/client.png",
				imgSelect: "/imgs/clientSelect.png"
			},
			{
				label: "认证源",
				path: "/certificationSource",
				img: "/imgs/certification.png",
				imgSelect: "/imgs/certificationSelect.png"
			},
			// {
			// 	label: "AI服务",
			// 	path: "/AIService",
			// 	img: "/imgs/ai.png",
			// 	imgSelect: "/imgs/aiSelect.png"
			// },
			{
				label: "审计日志",
				path: "/auditLog",
				img: "/imgs/log.png",
				imgSelect: "/imgs/logSelect.png"
			},
			{
				label: "系统设置",
				path: "/settings",
				img: "/imgs/settings.png",
				imgSelect: "/imgs/settingsSelect.png"
			},
			// {
			// 	label: "个性化",
			// 	path: "/Individual",
			// 	img: "/imgs/individual.png",
			// 	imgSelect: "/imgs/individualSelect.png"
			// }
      {
				label: "安全设置",
				path: "/securitySetting",
				img: "/imgs/settings.png",
				imgSelect: "/imgs/settingsSelect.png"
			},
		],
		is404: false
	},
	getters: {
		// 当前展示的菜单
		currentMenus: state => {
			// let menu = JSON.parse(JSON.stringify(state.managerModelMenu))
			// process.env.NODE_ENV == "production" ? menu.splice(5,1) : ''
			let userMenu = JSON.parse(JSON.stringify(state.userModelMenus))
			// 之前 qikan/journal 域名特例移除"我的应用"，由于 userModelMenus 已统一隐藏，此处无需再 splice
			return state.currentModel === "manager" ?
				state.managerModelMenu :
				userMenu
		}
	},
	mutations: {
		update_token(state, payload) {
			state.token = payload
		},
		// update_isAuth(state, payload) {
		//   state.isAuth = payload
		// },
		change_model(state, payload) {
			state.currentModel = payload
		},
		change_language(state, payload) {
			state.currentLanguage = payload
		},
		// 更新面包屑
		update_breadcrumb(state, payload) {
			if (getType(payload) === "[object Array]") {
				state.breadcrumb = [...payload]
			}
		},
		// 更新是否展示菜单服务
		update_show_nav(state, payload) {
			state.is404 = payload
		}
	}
}
